<template>
  <div class="c-page-title">
    <p class="title__sub">
      {{ titleData.sub }}
    </p>
    <p class="title__main">
      {{ titleData.main }}
    </p>
    <div class="deco"></div>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'PageTitle',
  props: {
    title: {
      type: Object,
      default: () => ({
        sub: '',
        main: '',
      }),
    },
  },
  setup(props) {
    const route = useRoute();

    const titleData = computed(() => {
      const { main: propMain, sub: propSub } = props.title;

      const t = {
        main: propMain || route.meta.banner?.mainTitle || route.meta?.title,
        sub: propSub || route.meta.banner?.subTitle,
      };

      return t;
    });

    return {
      route,
      titleData,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-page-title {
}
.title {
  &__sub {
    @include font-style($c-white, 20, 500, 2px);
    padding-bottom: 12px;

    &--hide {
      opacity: 0;
    }
  }

  &__main {
    @include font-style($c-white, 45, 700, 4.5px);
  }
}

.deco {
  background-color: $c-main-yellow;
  margin-top: 20px;
  width: 100px;
  height: 5px;
}
</style>
